import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Box, Container } from '@material-ui/core';
import { HeaderPopover } from './header-popover';
import ImageWebP from './ImageWebp';
import LogoBmcePng from '../assets/img/logoBmce.png';

export const Header: FC = () => (
  <AppBar
    elevation={0}
    sx={{
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 1px 2px rgba(9, 30, 66, 0.12)'
    }}
  >
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        flexDirection: {
          sm: 'row',
          xs: 'column'
        },
        py: 1.5
      }}
    >
      <Box
        component={RouterLink}
        to="/"
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ImageWebP
          childrenImage={<img style={{ maxWidth: '215px' }} src={LogoBmcePng} alt="Logo Bmce!" />}
        />
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <HeaderPopover />
    </Container>
  </AppBar>
);
